<template>
    <v-container app :fluid="true">
        <v-row>
            <v-col cols="12" class="pt-0">
                <v-card height="82vh">
                    <v-card-title>
                        <v-text-field
                            v-model="search"
                            append-icon="fas fa-search"
                            label="Buscar insumo"
                            hide-details
                            class="wost-text-input"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn @click="$refs.createOrUpdate.showForm('Nuevo insumo', 'create')" 
                            rised 
                            color="indigo" 
                            dark 
                            height="36" 
                            class="wost-btn-new"
                            v-if="verifyPermission('crear_insumos')">
                            <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo insumo
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div>
                            <v-data-table
                                class="wost-table"
                                :headers="headers"
                                :items="supplies"
                                item-key="name"
                                :search="search"
                                height="65vh"
                                v-if="verifyPermission('listar_insumos')"
                            >
                                <template v-slot:item.name="{item}">
                                    {{ item.name }}
                                    <span :class="'status-' + item.status.toLowerCase()">{{ item.status }}</span>
                                </template>
                                <template v-slot:item.category_id="{ item }">
                                    {{ item.category.name }}
                                </template>
                                <template v-slot:item.unit_id="{ item }">
                                    {{ item.unit.name }}
                                </template>
                                <template v-slot:item.cost="{ item }">
                                    {{ item.cost | currency('S/') }}
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <div class="datatable-cell-wrapper">
                                        <a href="#" title="Editar" class="btn-actions btn-edit" 
                                            @click="editSupply(item)"
                                            v-if="verifyPermission('actualizar_insumos')">
                                            <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                        </a>
                                        &nbsp;
                                        <a v-if="item.status  === 'activo' && verifyPermission('inactivar_insumos')" 
                                            href="#" 
                                            title="Inactivar" 
                                            class="btn-actions btn-delete" 
                                            @click="changeStatus(item, 'inactivar')">
                                            <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                        </a>
                                        <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_insumos')" 
                                            href="#" title="Activar" 
                                            class="btn-actions btn-delete" 
                                            @click="changeStatus(item, 'activar')">
                                            <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                        </a>
                                    </div>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <create-or-update ref="createOrUpdate" />
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import CreateOrUpdate from '../components/Supplies/CreateOrUpdate'

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'Supplies',
    components: {
        CreateOrUpdate
    },
    computed: {
        ...mapState('supplies', [
            'supplies',
            'supply'
        ]),
    },
    data() {
        return {
            search: '',
            headers: [
                { text: 'Descripción', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Categoría', value: 'category_id', align: 'left', sortable: false, class: 'header-table', width: 120 },
                { text: 'Und. de medida', value: 'unit_id', align: 'left', sortable: false, class: 'header-table', width: 140 },
                { text: 'Costo', value: 'cost', align: 'a-right', sortable: false, class: 'header-table', width: 110 },
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ]
        }
    },
    methods: {
        ...mapActions('supplies', [
            'getSupplies',
            'inactivateSupply'
        ]),
        ...mapMutations('supplies', [
            'setSupply',
            'setSupplyId'
        ]),
        editSupply(item) {
            this.setSupply(item)
            this.$refs.createOrUpdate.showForm('Modificar datos de insumo', 'update')
        },
        changeStatus(item, status) {
            this.setSupplyId(item.id)
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea " + status + " el insumo",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if(result.value){
                        if(result.value === true){
                            this.inactivateSupply()
                        }
                    }                    
                })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getSupplies()
    }
}
</script>

<style scoped>

</style>